module.exports = __webpack_public_path__ + "img/palespan-biodegradable.3b1e5af3.jpg";